<button class="btn btn-link" (click)="addToCartTemplateClick()">
  <i class="bi bi-card-list c-pointer"></i>
</button>
@if (addInfoBelow) {
  <div class="c-pointer" (click)="addToCartTemplateClick()" i18n="@@ProductCartListIconInfo">Add to a shopping list</div>
}
